import { render, staticRenderFns } from "./TravelerInfo.vue?vue&type=template&id=95af602e&scoped=true"
import script from "./TravelerInfo.vue?vue&type=script&lang=js"
export * from "./TravelerInfo.vue?vue&type=script&lang=js"
import style0 from "./TravelerInfo.vue?vue&type=style&index=0&id=95af602e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95af602e",
  null
  
)

export default component.exports